module.exports = __webpack_public_path__ + "media/camera-snap.c34896f2.wav";